var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[(_vm.loggedIn === null)?_c('v-main',[_c('v-container',{attrs:{"fill-height":""}},[_c('v-skeleton-loader',{attrs:{"boilerplate":"","type":"list-item-avatar-three-line@6"}})],1)],1):_c('router-view'),_c('NotificationsManager')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }